"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CancelationFailedBanner;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _Banners = require("../../../components/Banners");
var _PhoneNumberLink = _interopRequireDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
function CancelationFailedBanner(_ref) {
  let {
    phone
  } = _ref;
  const message = phone ? _messages.default.apptCancelationFailed : _messages.default.apptCancelationFailedNoProvider;
  return /*#__PURE__*/_react.default.createElement(_Banners.WarningBanner, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, message, {
    values: phone ? {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    } : undefined
  })));
}
CancelationFailedBanner.propTypes = {
  phone: _propTypes.string.isRequired
};
CancelationFailedBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CancelationFailedBanner",
  "props": {
    "phone": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};